import React, { useRef, useState, useEffect } from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaTimesCircle,
  FaCheckCircle,
  FaAddressBook,
  FaHourglassHalf,
  FaGrin,
  FaCalendarCheck,
  FaPrint,
  FaStar,
  FaQuestionCircle,
  FaCalendarTimes
} from "react-icons/fa"; // Import the FaTimesCircle icon
import { MdPayment } from "react-icons/md";
import { Modal, Box, Typography, Button, Snackbar, Alert } from "@mui/material";
import testImage from "../../Asset/image/yacht/cheesecake-thumb.jpg";
import "./bookingHistoryCard.scss";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import {
  cancelBookingAction,
  getBookingDetail,
  getBookingHistoryDetail,
  getYachtAction,
  updateBookingInfoAction,
  getBookCustomerDetailAction,
  getPaymentBillAction,
  getReviewListAction,
} from "../../redux/booking/BookingSlice";
import { sendEmailBookingAction } from "../../redux/Auth/AuthSlice";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { useReactToPrint } from "react-to-print";
import PrintableBill from "./PrintableBill";
import ReviewModal from "./ReviewModal";
import ReviewIcon from "../../Asset/icon/Review.svg";
import PrintIcon from "../../Asset/icon/Print.svg";
import PaymentModal from "../../components/card/paymentModal";
import Money from "../../Asset/icon/money.png";

const CardComponent = ({
  onBookNowClick,
  yachtImageUrl,
  yachtName,
  date,
  marinaNameEn,
  marinaNameTh,
  agent,
  status,
  rateType,
  price,
  provinceNameEng,
  provinceNameThai,
  pending,
  payment,
  idBooking,
  bookingNo,
  adult,
  child,
  infant,
  firstName,
  lastName,
  guest_name,
  email,
  mobileNo,
}) => {
  const printRef = useRef(null);
  const selectedLanguage = localStorage.getItem("selectedLanguage");
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const getToken = useSelector((state) => state.AuthSlice.token);
  const [loading, setLoading] = useState(true);
  const todos = useSelector((state) => state);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
          dispatch(getYachtAction({})),
          dispatch(getBookingHistoryDetail({ token: getToken })),
          dispatch(getBookCustomerDetailAction({})),
          dispatch(getPaymentBillAction({ token: getToken })),
        ]);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(getBookingHistoryDetail({ token: getToken }));
      // dispatch(getReviewListAction({}));
    }, 5000);

    return () => clearInterval(intervalId);
  }, [dispatch, getToken]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat().format(price);
  };

  const handleCancelClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const getStatusMessage = () => {
    switch (status) {
      case "INQUIRY":
        return t("Your inquiry has been received");
      case "PENDING":
        return t("Pending for your booking inquiry");
      case "BOOKED":
        return t("Your booking has been received");
      case "CANCELLED":
        return t("Thank you for your sharing experience");
      case "COMPLETED":
        return t("Thank you for your journey with us");
      case "CONFIRMED":
        return t("Ready for your journey");
      case "UNAVAILABLE":
        return t("Fully booked. Please change date or yacht");
      case "NO-SHOW":
        return t("Your booking has been marked as a no-show");
      default:
        return "";
    }
  };

  const getStatusIcon = () => {
    if (pending === 0) {
      return <FaHourglassHalf className="status-icon booked" />;
    } else {
      switch (status) {
        case "INQUIRY":
          return <FaQuestionCircle className="status-icon inquiry" />;
        case "BOOKED":
          return <FaAddressBook className="status-icon booked" />;
        case "CANCELLED":
          return <FaGrin className="status-icon cancelled" />;
        case "PENDING":
          return <FaCheckCircle className="status-icon pending" />;
        case "COMPLETED":
          return <FaCheckCircle className="status-icon completed" />;
        case "CONFIRMED":
          return <FaCalendarCheck className="status-icon confirmed" />;
        case "NO-SHOW":
          return <FaCalendarTimes className="status-icon no-show" />;
        default:
          return null;
      }
    }
  };

  const today = new Date().toISOString().split("T")[0];
  const tomorrow = new Date(Date.now() + 86400000).toISOString().split("T")[0];

  const [inquiryDate, setInquiryDate] = useState(today);
  const [selectedYacht, setSelectedYacht] = useState("");
  const [showUnavailableForm, setShowUnavailableForm] = useState(false);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(tomorrow);

  // ตัวอย่างฟังก์ชันส่ง inquiry
  const formatDate = (dateString) => {
    return dateString?.replace(/-/g, "/");
  };

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}/${mm}/${dd}`;
  };

  const handleSendInquiry = async () => {
    if (!selectedYacht) {
      setSnackbarSeverity("warning");
      setSnackbarMessage(t("Please select a yacht."));
      setSnackbarOpen(true);
      return;
    }

    if (rateType === "Overnight") {
      if (!startDate || !endDate) {
        setSnackbarSeverity("warning");
        setSnackbarMessage(t("Please select both start and end dates."));
        setSnackbarOpen(true);
        return;
      }
    } else {
      if (!inquiryDate) {
        setSnackbarSeverity("warning");
        setSnackbarMessage(t("Please select a date."));
        setSnackbarOpen(true);
        return;
      }
    }

    const selected = matchedYachts.find(
      (item) => String(item.id) === String(selectedYacht),
    );
    if (!selected) {
      setSnackbarSeverity("error");
      setSnackbarMessage(t("Invalid yacht selected."));
      setSnackbarOpen(true);
      return;
    }

    // เช็คว่าการจองซ้ำหรือไม่
    const bookingHistory = todos.Booking.BookingHistroy.results;

    if (!bookingHistory || bookingHistory.length === 0) {
    }

    const existingDuplicate = bookingHistory?.some((item) => {
      const sameBooking = Number(item.id_booking) === Number(idBooking);
      const sameYacht =
        Number(item.id_yachtInfo) === Number(selected.id_yachtInfo);
      const hasActivityDate = !!item.activity_date;

      if (sameBooking && sameYacht && hasActivityDate) {
        const existingDates = item.activity_date
          .split(",")
          .map((d) => d.trim());

        if (rateType === "Overnight") {
          const toISODate = (dateStr) => {
            const parts = dateStr.split(/[\/\-]/);
            if (parts.length === 3) {
              return `${parts[0]}-${parts[1]}-${parts[2]}`;
            }
            return dateStr;
          };

          const [existingStart, existingEnd] = existingDates;
          const existingStartDate = new Date(toISODate(existingStart));
          const existingEndDate = new Date(toISODate(existingEnd));
          const newStartDate = new Date(toISODate(startDate));
          const newEndDate = new Date(toISODate(endDate));

          const overlap =
            newStartDate <= existingEndDate && newEndDate >= existingStartDate;

          return overlap;
        } else {
          const formatted = formatDate(inquiryDate);
          return existingDates.includes(formatted);
        }
      }

      return false;
    });

    if (existingDuplicate) {
      setSnackbarSeverity("warning");
      setSnackbarMessage(
        t("This booking date already exists. Please choose another date."),
      );
      setSnackbarOpen(true);
      return;
    } else {
    }

    if (rateType === "Overnight") {
      const ratePlanList =
        todos?.YachtInfoSellingPriceRatePlanListSlice
          ?.YachtInfoSellingPriceRatePlanList?.results || [];

      // หา rate plan ของเรือที่เลือก
      const matchedRatePlan = ratePlanList.find(
        (plan) =>
          Number(plan.id_sellingPrice) === Number(selected.id_sellingPrice),
      );

      if (matchedRatePlan?.minimum_stay) {
        const minStay = Number(matchedRatePlan.minimum_stay);

        // คำนวณจำนวนคืน เช่น 20 → 21 = 1 คืน
        const start = new Date(startDate);
        const end = new Date(endDate);

        const diffTime = end - start;
        const nights = diffTime / (1000 * 60 * 60 * 24);

        if (nights < minStay) {
          setSnackbarSeverity("warning");
          setSnackbarMessage(
            t(
              `Minimum stay is ${minStay} nights. Please select a longer date range.`,
            ),
          );
          setSnackbarOpen(true);
          return;
        }
      }
    }

    const Vat = todos?.Booking?.yachtResult?.data?.find(
      (y) => y.id_yacht === selected.id_yacht,
    );

    // ✅ ตรวจสอบ VAT (ถ้ามีให้บวกเพิ่ม)
    let totalPrice = Number(selected.sell);
    const vatValue = Vat?.vat;

    if (vatValue === 1 || vatValue === true) {
      const vatAmount = totalPrice * 0.07; // คิด VAT 7%
      totalPrice += vatAmount;
    }

    const payload = {
      id_booking: idBooking,
      id_yachtInfo: selected.id_yachtInfo,
      yacht_name: selected.name,
      id_yacht: selected.id_yacht,
      sum_all_price: totalPrice,
      status: "INQUIRY",
      issued_date: getTodayDate(),
      activity_date:
        rateType === "Overnight"
          ? `${formatDate(startDate)}, ${formatDate(endDate)}`
          : formatDate(inquiryDate),
    };

    try {
      const result = await dispatch(updateBookingInfoAction(payload));
      setSnackbarSeverity("success");
      setSnackbarMessage(t("Inquiry sent successfully!"));
      setSnackbarOpen(true);

      // ดึงข้อมูลเจ้าของเรือ
      const yachtOwnerData = todos?.Booking?.yachtResult?.data?.find(
        (y) => y.id_yacht === selected.id_yacht,
      );
      const yachtOwnerEmail = yachtOwnerData?.email;

      if (!yachtOwnerEmail) {
        console.warn("Yacht owner's email not found.");
        return;
      }

      // เตรียมข้อมูลสำหรับอีเมล
      const emailData = {
        recipient: yachtOwnerEmail,
        subject: `New Booking No. [#${bookingNo}] | TakeMyYacht.com`,
        dear: yachtOwnerData?.name_yacht,
        firstName: firstName,
        lastName: lastName,
        email: email,
        tel: mobileNo,
        message: `
  <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
  <tr>
    <td align="center">
      <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="700" style="font-family: Arial, sans-serif; color: #333; text-align: left; background-color: #ffffff;">
        <tr>
          <td style="padding: 30px;">

            <!-- Header -->
            <h2 style="color: #004080; margin-bottom: 10px;">📌 New Yacht Booking Inquiry Received</h2>
            <p style="font-size: 15px; color: #555;">Dear ${yachtOwnerData?.name_yacht},</p>
            <p style="font-size: 15px; color: #555;">A new yacht booking has been received. Please review the details below:</p>

            <!-- Booking Detail Box -->
            <div style="background-color: #f0f6ff; border-left: 5px solid #004080; padding: 20px; margin: 20px 0; border-radius: 8px;">
              <p style="margin: 5px 0;"><strong>Booking ID:</strong> ${idBooking}</p>
              <p style="margin: 5px 0;"><strong>Booking NO:</strong> ${bookingNo}</p>
              <p style="margin: 5px 0;"><strong>Guest Name:</strong> ${guest_name}</p>
              <p style="margin: 5px 0;"><strong>Email:</strong> ${email}</p>
              <p style="margin: 5px 0;"><strong>Phone:</strong> ${mobileNo}</p>
              <p style="margin: 5px 0;"><strong>Yacht Name:</strong> ${selected.name}</p>
              <p style="margin: 5px 0;"><strong>Activity Type:</strong> ${rateType}</p>
              <p style="margin: 5px 0;"><strong>Booking Date:</strong> ${payload.activity_date}</p>
              <p style="margin: 5px 0;"><strong>Number of Passengers:</strong> Adults ${adult}, Children ${child}, Infants ${infant}</p>
              <p style="margin: 5px 0;"><strong>Total Price:</strong> ${totalPrice} THB</p>
              <p style="margin: 5px 0;"><strong>Booking Status:</strong> <span style="color:#e67e22; font-weight:bold;">PENDING</span></p>
            </div>

            <!-- Call to Action -->
            <p style="font-size: 15px; color: #555;">Please confirm your availability using the options below:</p>

            <div style="margin-top: 20px; text-align: center;">
              <a href="https://takemyyacht.com/email-action?recipient=${yachtOwnerEmail}&email=${email}&firstName=${firstName}&lastName=${lastName}&id_booking=${idBooking}&status=UNAVAILABLE&booking_no=${bookingNo}"
                 style="display: inline-block; background-color: #ffffff; color: #d32f2f; border: 2px solid #d32f2f; padding: 12px 24px; border-radius: 6px; font-weight: bold; text-decoration: none; margin-right: 10px;">
                  Occupied
              </a>

              <a href="https://takemyyacht.com/email-action?recipient=${yachtOwnerEmail}&email=${email}&firstName=${firstName}&lastName=${lastName}&id_booking=${idBooking}&status=PENDING&booking_no=${bookingNo}"
                 style="display: inline-block; background-color: #004080; color: white; border: 2px solid #004080; padding: 12px 24px; border-radius: 6px; font-weight: bold; text-decoration: none;">
                  Vacant
              </a>
            </div>

            <!-- Footer -->
            <p style="margin-top: 40px; font-size: 14px; color: #555;">Best regards,<br/>TakeMyYacht Team</p>

          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
`,
      };
      await dispatch(sendEmailBookingAction(emailData));
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarMessage(t("Failed to send inquiry."));
      setSnackbarOpen(true);
    }
  };

  const [cancellationReason, setCancellationReason] = useState("");
  const [agreedToRefundPolicy, setAgreedToRefundPolicy] = useState(false);

  const handleSubmitCancellation = async () => {
    if (!cancellationReason.trim()) {
      setSnackbarSeverity("warning");
      setSnackbarMessage(t("Please enter a reason before submitting."));
      setSnackbarOpen(true);
      return;
    }

    const response = await dispatch(
      cancelBookingAction({
        id_booking: idBooking,
        cancel_reason: cancellationReason,
        refund: payment === 1 ? 1 : 0,
        addon: 0,
      }),
    );

    if (response.status) {
      dispatch(getBookingHistoryDetail({ token: getToken }));
      dispatch(getBookingDetail);
      setShowModal(false);
    } else {
      setSnackbarSeverity("error");
      setSnackbarMessage(response.msg || t("Cancellation failed"));
      setSnackbarOpen(true);
    }
  };

  const matchedYachts = todos.YachtSlice.Yacht?.results
    ?.filter((yacht) => yacht.name_yacht === agent)
    .flatMap((yacht) => {
      const matches =
        todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList?.results?.filter(
          (info) =>
            Number(info.id_yacht) === Number(yacht.id_yacht) &&
            info.rate_type === rateType,
        ) || [];

      return matches.map((match, index) => ({
        id: index,
        id_yacht: match.id_yacht,
        id_sellingPrice: match.id_sellingPrice,
        name: match.name_yacht_yachtInfo,
        sell: match.value_sellingPrice,
        id_yachtInfo: match.id_yachtInfo,
      }));
    });

  const vatInfo = todos?.Booking?.yachtResult?.data?.find(
    (y) => Number(y.id_yacht) === Number(matchedYachts?.[0]?.id_yacht),
  );

  // ถ้าไม่มี ให้ default เป็น 0
  const vat = vatInfo?.vat ?? 0;

  const handlePrint = useReactToPrint({
    contentRef: printRef, // ✅ ใช้ contentRef แทน content()
    documentTitle: "Receipt-Tax-Invoice",
  });

  const [isPrintReady, setIsPrintReady] = useState(false);

  const handlePrintClick = async () => {
    if (printRef.current) {
      // รอจนกว่า loading div จะหายไป (ไม่มีคำว่า "Loading")
      const waitForContent = () =>
        new Promise((resolve) => {
          const check = () => {
            const text = printRef.current?.innerText || "";
            if (!text.includes("Loading")) {
              resolve();
            } else {
              setTimeout(check, 200);
            }
          };
          check();
        });

      await waitForContent();
      handlePrint();
    }
  };

  const [showReviewModal, setShowReviewModal] = useState(false);

  const handleReviewClick = () => {
    setShowReviewModal(true);
  };

  const handleCloseReview = () => {
    setShowReviewModal(false);
  };

  const handlePayClick = () => {
    setShowPaymentModal(true);
  };

  return (
    <Card className="cardBH">
      <div className="status-message" title={getStatusMessage(status)}>
        {getStatusIcon()}
        <span>{getStatusMessage(status)}</span>
      </div>
      <Card.Body className="cardBH-body">
        <Row className="h-100 align-items-center">
          <Col md={2} className="p-0">
            <Card.Img src={yachtImageUrl || testImage} />
          </Col>
          <Col md={3} className="d-flex flex-column justify-content-center">
            <div className="d-flex align-items-center">
              <Card.Title className="mb-0 cardBH-title">
                {" "}
                {yachtName}
              </Card.Title>
              <span className="text-muted date-size">{date}</span>
            </div>
            <Card.Text className="mt-2 cardBH-text">
              <FaMapMarkerAlt />{" "}
              {selectedLanguage === "en" ? marinaNameEn : marinaNameTh},{" "}
              {selectedLanguage === "en" ? provinceNameEng : provinceNameThai}
            </Card.Text>
            <Card.Link className="cardBH-link" href="#">
              {t("Operated")} {agent}
            </Card.Link>
          </Col>
          <Col
            md={2}
            className="col-center w-full text-end"
          >
            <h2 className="day-text-bh">฿{formatPrice(price)}</h2>
          </Col>
          <Col md={2} className="col-center ">
            <h2 className="day-text-bh"> {t(rateType)} </h2>
          </Col>
          <Col md={3} className="d-flex status-col col-center">
            {status === "PENDING" ? (
              <button
                className="book-now-button"
                onClick={() => onBookNowClick(idBooking)}
              >
                {t("Book Now")}
              </button>
            ) : (status === "BOOKED" ||
              status === "CONFIRMED" ||
              status === "COMPLETED") &&
              payment === 0 ? (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>{t("Payment")}</Tooltip>}
              >
                <div className="inline-block">
                  <img
                    src={Money}
                    alt="Payment"
                    onClick={handlePayClick}
                    className="clickable-thumbnail"
                  />
                </div>
              </OverlayTrigger>
            ) : status === "UNAVAILABLE" ? (
              <div className="unavailable-wrapper">
                <button
                  className="change-button"
                  onClick={() => setShowUnavailableForm(!showUnavailableForm)}
                >
                  {t("Change")}
                </button>

                {showUnavailableForm && (
                  <div className="unavailable-box">
                    <div className="form-row-date">
                      <label htmlFor="date">{t("Date")}</label>
                      {rateType === "Overnight" ? (
                        <div className="date-range-column">
                          <div className="date-group">
                            <label htmlFor="startDate">{t("Start Date")}</label>
                            <Form.Control
                              type="date"
                              id="startDate"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                              min={today}
                            />
                          </div>
                          <div className="date-group">
                            <label htmlFor="endDate"> {t("End Date")}</label>
                            <Form.Control
                              type="date"
                              id="endDate"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                              min={startDate || today}
                            />
                          </div>
                        </div>
                      ) : (
                        <Form.Control
                          type="date"
                          id="date"
                          value={inquiryDate}
                          onChange={(e) => setInquiryDate(e.target.value)}
                          min={today}
                        />
                      )}
                    </div>

                    <div className="form-row-yacht">
                      <label htmlFor="yacht">{t("Yacht")}</label>
                      <select
                        id="yacht"
                        value={selectedYacht}
                        onChange={(e) => setSelectedYacht(e.target.value)}
                      >
                        <option value="">{t("Select Yacht")}</option>
                        {matchedYachts.map((item, index) => (
                          <option key={item.id} value={item.id}>
                            {item.name} (฿{formatPrice(item.sell)})
                          </option>
                        ))}
                      </select>
                    </div>

                    <button className="send-button" onClick={handleSendInquiry}>
                      {t("Send inquiries")}
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <span className="text-muted">
                {payment === 1 &&
                  (status === "CONFIRMED" || status === "COMPLETED") ? (
                  <div className="flex-align-center">
                    {/* Print Bill */}

                    {/* Review */}
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="review-tooltip" className="custom-tooltip">{t("Write Review")}</Tooltip>}
                    >
                      <div className="inline-block">
                        <img
                          src={ReviewIcon}
                          alt="Write Review"
                          onClick={handleReviewClick}
                          className="thumbnail-small"
                        />
                      </div>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="print-tooltip" className="custom-tooltip">{t("Print Bill")}</Tooltip>}
                    >
                      <div>
                        <img
                          src={PrintIcon}
                          alt="Print Bill"
                          onClick={handlePrintClick}
                          className="thumbnail-43"
                        />
                      </div>
                    </OverlayTrigger>
                  </div>
                ) : (
                  t(status)
                )}
              </span>
            )}

            {
              status !== "CANCELLED" && status !== "NO-SHOW" && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="cancel-tooltip" className="custom-tooltip">{t("Cancel Booking")}</Tooltip>} // Tooltip content
                >
                  <div>
                    <FaTimesCircle
                      className="cancel-button"
                      color={status === "CANCELLED" ? "grey" : "red"} // Change color based on status
                      size={30}
                      onClick={
                        status === "CANCELLED" ? null : handleCancelClick
                      }
                      style={{
                        cursor:
                          status === "CANCELLED" ? "not-allowed" : "pointer", // Change cursor based on status
                        marginLeft: "10px",
                      }}
                    />
                  </div>
                </OverlayTrigger>
              )}
          </Col>
        </Row>
      </Card.Body>

      <div className="offscreen-element">
        <PrintableBill
          ref={printRef}
          id_booking={idBooking}
          price={price}
          rateType={rateType}
          date={date}
          vats={vat}
        />
      </div>

      <ReviewModal
        show={showReviewModal}
        onClose={handleCloseReview}
        id_booking={idBooking}
      />

      {/* Cancellation Modal */}
      {showModal && (
        <div
          className="overlay-backdrop"
          onClick={handleCloseModal}
        >
          <div
            className="modal-content2"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              className="modal-header2"
            >
              <h4 className="m-0" style={{ fontWeight: "500" }}>{t("Cancel")}</h4>
              <button
                onClick={handleCloseModal}
                className="btn-close-icon2"
              >
                &times;
              </button>
            </div>

            {/* Textarea */}
            <div className="mb-20">
              <textarea
                placeholder={t("Reason for cancellation")}
                value={cancellationReason}
                onChange={(e) => setCancellationReason(e.target.value)}
                className="textarea-review"
              />
            </div>

            {/* Footer */}
            <div
              className="flex-between-center"
            >
              <div className="flex-align-center">
                <input
                  type="checkbox"
                  id="agreeRefund"
                  checked={agreedToRefundPolicy}
                  onChange={(e) => setAgreedToRefundPolicy(e.target.checked)}
                  className="mr-8 cursor-pointer"
                />
                <label
                  htmlFor="agreeRefund"
                  className="text-body-sm"
                >
                  {t("I agree to the")}{" "}
                  <a
                    href="/refundPolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-primary-bold"
                  >
                    {t("Refundable policy")}
                  </a>
                </label>
              </div>
              <button
                onClick={handleSubmitCancellation}
                disabled={!agreedToRefundPolicy}
                style={{
                  backgroundColor: agreedToRefundPolicy ? "#002b5c" : "#ccc",
                  color: "#fff",
                  padding: "10px 24px",
                  border: "none",
                  borderRadius: "20px",
                  cursor: agreedToRefundPolicy ? "pointer" : "not-allowed",
                  fontWeight: "bold",
                  fontSize: "15px",
                }}
              >
                {t("Submit")}
              </button>
            </div>
          </div>
        </div>
      )}

      <PaymentModal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        bookingId={idBooking}
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default CardComponent;
